"use strict";

exports.__esModule = true;
exports.buildDeviceDataItemQuery = buildDeviceDataItemQuery;
exports.getBinSize = getBinSize;
function getBinSize(startMillis, endMillis, width) {
  var duration = endMillis - startMillis;
  var secondsPerPixel = Math.round(duration / (width * 1000)) * 2;
  return (secondsPerPixel >= 1 ? secondsPerPixel : 1) + "s";
}
function buildDeviceDataItemQuery(props) {
  var deviceUUID = props.deviceUUID,
    dataItem = props.dataItem,
    _props$interval = props.interval,
    startMillis = _props$interval.startMillis,
    endMillis = _props$interval.endMillis,
    width = props.width;
  var binSize = getBinSize(startMillis, endMillis, width);
  return {
    device: deviceUUID,
    dataItemName: dataItem.name,
    binSize: binSize,
    stats: ["avg"],
    start: new Date(startMillis).toISOString(),
    end: new Date(endMillis).toISOString(),
    category: dataItem.category
  };
}